import React, { useState } from 'react'
import useDeliveryPickupAxios, { useDeliveryPickupFormData } from '../utils/axios';
import { useDispatch } from 'react-redux';
import { setDashboardOrdersSummary, setLastRequest, setOverviewOrders } from '../features/overviewSlice';

function useRecentOrdersApi () {

    const DeliveryPortalAxios = useDeliveryPickupAxios();
    const DeliveryPortalAxios1 = useDeliveryPickupFormData();
    const DeliveryPortalClient = DeliveryPortalAxios;
    DeliveryPortalClient.defaults.timeout = 600000;
    const DeliveryPortalClient1 = DeliveryPortalAxios1;
    DeliveryPortalClient1.defaults.timeout = 600000;

    const [recentOrders, setRecentOrders] = useState([])
    const [totalNbOfPage, setTotalNbOfPage] = useState(1);
    const [totalCount, setTotalCount] = useState(1);
    // const [overviewOrders, setOverviewOrders] = useState([]);
    const [overviewLoading, setOverviewLoading] = useState(false);

    const dispatch = useDispatch();

    const GetRecentOrders = async () => {
        try {
            const response = await DeliveryPortalAxios.get('/RecentOrders/GetRecentOrders')

            if(response && response.data.payload) {
                setRecentOrders(response.data.payload.orders)
            }
        } catch (e) {
            return e;
        }
    }

    const GetDashboardOrdersSummary = async () => {
        try {
            const response = await DeliveryPortalAxios.get("/RecentOrders/GetDashboardOrdersSummary");

            if(response && response.data) {
                const ordersSummary = response.data.payload;
                dispatch(setDashboardOrdersSummary(ordersSummary));
            }
        } catch (error) {
            console.error(error);
        }
    }

    const GetOverviewOrders = async (pageNb, dateFrom, dateTo, status, orderID, type, clientFullName) => {
        setOverviewLoading(true);
        try {
            const res = await DeliveryPortalAxios.post("/RecentOrders/GetOverviewOrders", {
                dateFrom: new Date(dateFrom).toISOString(),
                dateTo: new Date(dateTo).toISOString(),
                pageNumber: pageNb,
                pageSize: 10,
                status: status,
                orderID: orderID,
                type: type,
                clientFullName: clientFullName
            });
    
            dispatch(setOverviewOrders(res.data.payload.orders));
            dispatch(setLastRequest({ pageNb, dateFrom, dateTo, status, orderID, type, clientFullName }))
    
            if (res.data.payload?.orders.length === 0) {
                setTotalNbOfPage(0);
                setTotalCount(0);
            } else {
                setTotalNbOfPage(res.data.payload.totalPages);
                setTotalCount(res.data.payload.totalOrdersCount);
            }
    
        } catch (error) {
            console.error("Request failed:", error);
        } finally {
            setOverviewLoading(false);
        }
    };
    

  return {
    GetRecentOrders,
    recentOrders,
    GetDashboardOrdersSummary,
    GetOverviewOrders,
    // overviewOrders,
    totalCount,
    totalNbOfPage,
    overviewLoading
  }
}

export default useRecentOrdersApi;